<template>
	<div id="app">
		<div class="mode-view">
			<div v-for="item in 200" :key="item" class="mode-view-flashing"></div>
			<div class="star"></div>
			<div class="star" style="top: 4vw; left: 35vw; animation-delay: 3s;"></div>
			<div class="star" style="top: 2vw; left: 47.3vw; animation-delay: 2s;"></div>
			<div class="star" style="top: 6vw; left: 34.75vw; animation-delay: 4s;"></div>
			<div class="star" style="top: 6vw; left: 50vw; animation-delay: 2s;"></div>
			<div class="star" style="top: 6vw; left: 63.25vw; animation-delay: 4s;"></div>
			<div class="star" style="top: 6vw; left: 78.25vw; animation-delay: 1.5s;"></div>
			<div class="star" style="top: 6vw; left: 95vw; animation-delay: 3s;"></div>
			<div class="star" style="top: 6vw; left: 82.5vw; animation-delay: 1.7s;"></div>
			<div class="star" style="top: 6vw; left: 115vw; animation-delay: 4s;"></div>
		</div>
		<div id="outline">
			<div class="outline-header">
				<div class="outline-header-bg">
					<img src="../../../assets/service_center/home/headerbg.png" alt="">
				</div>
				<div class="outline-header-left">

				</div>
				<div class="outline-header-center">
					<div class="outline-header-center-top">

						<img src="../../../assets/service_center/home/left-icon.png" alt="left">
						<!-- <dv-decoration-1 style="width:200px;height:50px;" /> -->
						<div class="outline-header-center-title">
							<!-- 逸慧家智慧用电与消防安全隐患预警系统 -->
							{{TittleName}}
						</div>
						<!-- <dv-decoration-1 style="width:200px;height:50px; transform: rotateY(180deg);" /> -->
						<img src="../../../assets/service_center/home/right_icon.png" alt="right">

					</div>
					<div class="outline-header-center-bottom" style="letter-spacing: 0px;">
						<!-- Smart electricity equipment supervision -->
						{{TittleNameEN}}
					</div>
				</div>
				<div class="outline-header-right">
					<img @click="onBackClick" src="../../../assets/service_center/home/return.png" alt="返回">
				</div>
				<div class="outline-and"></div>
			</div>
			<div class="outline-content">
				<div class="outline-left">
					<div class="outline-left-title">最近报警条目列表</div>
					<div class="outline-left-list">
						<div class="outline-left-lists" :class="{'outline_offset': offsetMsg}" v-if="GetAbDataLists.length > 0">
							<div class="outline-left-top-item" v-for="(item, index) in GetAbDataLists" :key="item.Id">
								<Tooltip :content="item.AbnormalTime" placement="right">
									<div class="outline-left-top-item-time">
										<!-- :class="{'latest': index < 3}" -->
										<div class="outline-left-top-item-time-bg-img">
											<img v-if="index < 3" src="../../../assets/service_center/home/select_arrow.png" alt="">
											<img v-else src="../../../assets/service_center/home/select_arrow_2.png" alt="">
										</div>
										<template v-if="index < 3">
											<span style="color: #000000;">{{item.AbnormalTime | intercept}}</span>
										</template>
										<template v-else>
											<span style="color: #fff;">{{item.AbnormalTime | intercept}}</span>
										</template>
									</div>
								</Tooltip>

								<div class="outline-left-top-item-name">
									{{item.UserDeviceName}}
								</div>
								<div class="outline-left-top-item-group">{{item.AbnormalName}}</div>
							</div>
						</div>
						<div class="map-right-group-list-none" v-else>暂无报警信息</div>

						<Spin size="large" fix v-if="!GetAbDataListsMsg"></Spin>
					</div>
					<div class="outline-left-title">最近报警已处理情况</div>
					<div class="outline-left-bottom">
						<div class="outline-left-bottom-detail">
							<div class="outline-left-bottom-detail-div"></div>
							<div class="outline-left-bottom-detail-text">已处理</div>
							<div class="outline-left-bottom-detail-number">
								<span>
									<span id="count_to_42" class="count-to-count-text">{{processed ? processed : '0'}}</span>
									<span class="count-to-unit-text"></span>
								</span>
							</div>
						</div>
						<div class="outline-left-bottom-chart">
							<div id="myChart" :style="{width: '100%', height: '100%'}"></div>
						</div>
						<Spin size="large" fix v-if="!GetEchartAbDataMsg"></Spin>
					</div>
					<div class="outline-left-absolute">
						<img src="../../../assets/service_center/home/outlineBorder1.png" alt="">
					</div>
					<div class="outline-left-absolute1">
						<img src="../../../assets/service_center/home/outlineBorder1.png" alt="">
					</div>
				</div>

				<div class="outline-center">

					<div class="outline-center-data-alarm2">
						<div class="outline-center-data-alarm2-item" @click="openPopup(3, '今日已处理', 2)">
							今日处理数：
							<span>
								<span>
									<span id="itemImg1" class="count-to-count-text">0</span>
									<span class="count-to-unit-text"></span>
								</span>
							</span>
						</div>
						<div class="outline-center-data-alarm2-item" @click="openPopup(3, '今日未处理', 1)">
							今日未处理数：
							<span>
								<span>
									<span id="itemImg2" class="count-to-count-text">0</span>
									<span class="count-to-unit-text"></span>
								</span>
							</span>
						</div>
					</div>

					<!-- <img class="outline-center-light1" src="https://big.darongshu360.com/img/earthbg1.2604d64e.png" alt=""> -->
					<div class="outline-center-data">
						<div class="outline-center-data-alarm" @click="openPopup(1, '设备报警数')">

							<!-- <span class="outline-center-data-alarm-number">
								<span class="item">
									<span id="count_to_124" class="count-to-count-text">{{GetNavDataYHJs.todayAb}}</span>
									<span class="count-to-unit-text"></span>
								</span>
							</span> -->
							<div id="itemImg3" class="outline-center-data-alarm-code">0</div>
							<div class="outline-center-data-alarm-title">设备报警数</div>


						</div>
						<div class="outline-center-data-circle">
							<div class="outline-center-data-circle-item" @click="openPopup(5, '当前报警住户')">

								<div id="itemImg4" class="outline-center-data-circle-item-title1" style="height: 3vw;">
									0
									<!-- <dv-digital-flop :config="AbTenants" style="width:100%;height:2.5vw" /> -->
								</div>
								<div class="outline-center-data-circle-item-title">当前报警住户数</div>
							</div>
							<div class="outline-center-data-circle-item" @click="openPopup(4, '当前报警设备')">
								<div id="itemImg5" class="outline-center-data-circle-item-title1" style=" height: 3vw;">
									0
									<!-- <dv-digital-flop :config="abDevices" style="width:100%;height:2.5vw" /> -->
								</div>
								<div class="outline-center-data-circle-item-title">当前报警设备数</div>
							</div>
							<div class="outline-center-data-circle-item" @click="openPopup(2, '设备在线列表', '1')">
								<div id="itemImg6" class="outline-center-data-circle-item-title1" style=" height: 3vw;">
									0
									<!-- <dv-digital-flop :config="ZxDevices" style="width:100%;height:2.5vw" /> -->
								</div>
								<div class="outline-center-data-circle-item-title">当前设备在线数</div>
							</div>
							<div class="outline-center-data-circle-item" @click="openPopup(2, '设备离线列表', '0')">
								<div id="itemImg7" class="outline-center-data-circle-item-title1" style="height: 3vw;">
									0
									<!-- <dv-digital-flop :config="LxDevices" style="width:100%;height:2.5vw" /> -->
								</div>
								<div class="outline-center-data-circle-item-title">当前设备离线数</div>
							</div>
						</div>
					</div>


				</div>

				<div class="outline-right">
					<div class="outline-right-title">设备状态</div>
					<div class="outline-right-top">
						<div class="outline-right-top-chart">
							<div id="myChart1" :style="{width: '100%', height: '100%'}"></div>
						</div>
						<div class="outline-right-top-list-tab">
							<div class="outline-right-top-tab-item">设备位置</div>
							<div class="outline-right-top-tab-item">设备名称</div>
							<div class="outline-right-top-tab-item">开关状态</div>
						</div>
						<div class="outline-right-top-list" id="wrapper">
							<div id="content" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 0">
								<div class="outline-right-top-list-item" v-for="(item, index) in GetDeviceDataLists" :key="index">
									<div class="outline-right-top-list-item-time2" style="padding: 0 0.5vw;" :title="item.CommunityName">{{item.CommunityName}}</div>
									<div class="outline-right-top-list-item-name2">{{item.UserDeviceName}}</div>
									<div class="outline-right-top-list-item-group2">
										<img v-if="item.SwitchStatus == 1" src="../../../assets/service_center/home/close.png" alt="">
										<img v-else-if="item.SwitchStatus == 2" src="../../../assets/service_center/home/open.png" alt="">
										<span v-else>--</span>
									</div>
									<!-- {{item.SwitchStatus == 1 ? '合闸' : '分闸'}} -->
								</div>
							</div>
							<div id="fakeContent" class="outline-right-top-lists" v-if="GetDeviceDataLists.length > 4"></div>

							<div class="map-right-group-list-none" v-if="GetDeviceDataLists.length == 0">暂无状态信息</div>
							<Spin size="large" fix v-if="!GetDeviceDataListsMsg"></Spin>
						</div>

					</div>
					<div class="outline-right-title">操作日志</div>
					<div class="outline-right-bottom">
						<div class="outline-right-bottom-list-tab">
							<div class="outline-right-bottom-tab-item">时间</div>
							<div class="outline-right-bottom-tab-item">设备</div>
							<div class="outline-right-bottom-tab-item">操作</div>
						</div>
						<div class="outline-right-bottom-list">
							<div class="outline-right-top-lists1" v-if="GetOperationDataList.length > 0">
								<div class="outline-right-top-list-item" v-for="(item, index) in GetOperationDataList" :key="index">
									<div class="outline-right-top-list-item-time">{{item.CreateTime}}</div>
									<div class="outline-right-top-list-item-name">{{item.UserDeviceName}}</div>
									<div class="outline-right-top-list-item-group">{{item.Remark}}</div>
								</div>
							</div>
							<div class="map-right-group-list-none" v-else>暂无操作日志</div>
							<Spin size="large" fix v-if="!GetOperationDataListMsg"></Spin>
						</div>
					</div>
					<div class="outline-right-absolute">
						<img src="../../../assets/service_center/home/outlineBorder2.png" alt="">
					</div>
					<div class="outline-right-absolute1">
						<img src="../../../assets/service_center/home/outlineBorder2.png" alt="">
					</div>
				</div>

				<!-- :class="{'hiddenTop' : !userListHideIndex}" -->
				<div class="outline-view" v-if="popupState" @click="shutDown('self')">
					<div class="outline-top" @click.stop="shutDown()">
						<dv-border-box-11 backgroundColor="rgba(7,22,55, 0.7)" :title="popupTitle">
							<div class="outline-remove" @click="shutDown('self')">
								<img src="../../../assets/service_center/home/remove.png" alt="">
							</div>
							<div class="outline-mode">
								<template v-if="popupType == 1">
									<div class="map-bottom-content-tab">
										<div class="map-bottom-content-tab-item">设备名称</div>
										<div class="map-bottom-content-tab-item">设备编号</div>
										<div class="map-bottom-content-tab-item">时间</div>
										<div class="map-bottom-content-tab-item">类型</div>
										<div class="map-bottom-content-tab-item tabHandle">操作</div>
									</div>
									<div class="map-bottom-list">
										<div id="content" class="map-bottom-lists" v-if="DeviceAbnormalList.length > 0">
											<div class="map-bottom-list-item" v-for="item in DeviceAbnormalList" :key="item.Id">
												<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
												<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
												<div class="map-bottom-list-item-date">{{item.AbnormalTime}}</div>
												<div class="map-bottom-list-item-type">{{item.AbnormalName}}</div>
												<div class="map-bottom-list-item-handle">
													<div class="ivu-dropdown">
														<div class="" style="margin-top: 0.1vw;">
															<div class="map-bottom-list-item-handle-btn">
																<Dropdown trigger="click" style="width: 5vw;">
																	<a href="javascript:void(0)">
																		请处理
																		<Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
																	</a>
																	<DropdownMenu slot="list" style="width: 5vw;">
																		<DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">处理</DropdownItem>
																		<DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">误报</DropdownItem>
																	</DropdownMenu>
																</Dropdown>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="map-right-group-list-none" v-if="DeviceAbnormalList.length == 0">暂无告警消息</div>
									</div>
									<div class="user-top-list-page">
										<Page :total="DeviceAbnormalTotalCount" @on-change="DeviceAbnormalChange" @on-page-size-change="DeviceAbnormalSizeChange" size="small" show-total show-elevator show-sizer placement="top" />
									</div>
								</template>
								<template v-else-if="popupType == 2">
									<div class="map-bottom-content-tab">
										<div class="map-bottom-content-tab-item">设备名称</div>
										<div class="map-bottom-content-tab-item">设备编号</div>
										<div class="map-bottom-content-tab-item">设备地址</div>
										<div class="map-bottom-content-tab-item">通讯时间</div>
										<div class="map-bottom-content-tab-item tabHandle">设备状态</div>
									</div>
									<div class="map-bottom-list">
										<div id="content" class="map-bottom-lists" v-if="DeviceLists.length > 0">
											<div class="map-bottom-list-item" v-for="item in DeviceLists" :key="item.Id">
												<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
												<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
												<div class="map-bottom-list-item-date">{{item.CommunityName}}</div>
												<div class="map-bottom-list-item-date">{{item.UpdateTime}}</div>
												<div class="map-bottom-list-item-handle">{{item.SwitchStatus == 1 ? '合闸' : item.SwitchStatus == 2 ? '分闸' : '--'}}</div>
											</div>
										</div>
										<div class="map-right-group-list-none" v-if="DeviceLists.length == 0">暂无设备</div>
									</div>
									<div class="user-top-list-page">
										<Page :total="DeviceTotal" @on-change="DeviceChange" @on-page-size-change="DeviceSizeChange" size="small" show-total show-elevator show-sizer placement="top" />
									</div>
								</template>
								<template v-else-if="popupType == 3">
									<div class="map-bottom-content-tab">
										<div class="map-bottom-content-tab-item">设备名称</div>
										<div class="map-bottom-content-tab-item">设备编号</div>
										<div class="map-bottom-content-tab-item">时间</div>
										<div class="map-bottom-content-tab-item">类型</div>
										<div class="map-bottom-content-tab-item tabHandle">操作</div>
									</div>
									<div class="map-bottom-list">
										<div id="content" class="map-bottom-lists" v-if="DeviceAbnormalList.length > 0">
											<div class="map-bottom-list-item" v-for="item in DeviceAbnormalList" :key="item.Id">
												<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
												<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
												<div class="map-bottom-list-item-date">{{item.AbnormalTime}}</div>
												<div class="map-bottom-list-item-type">{{item.AbnormalName}}</div>
												<div class="map-bottom-list-item-handle">
													<template v-if="DeviceCategory == 1">
														<div class="ivu-dropdown">
															<div class="" style="margin-top: 0.1vw;">
																<div class="map-bottom-list-item-handle-btn">
																	<Dropdown trigger="click" style="width: 5vw;">
																		<a href="javascript:void(0)">
																			请处理
																			<Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
																		</a>
																		<DropdownMenu slot="list" style="width: 5vw;">
																			<DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">处理</DropdownItem>
																			<DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">误报</DropdownItem>
																		</DropdownMenu>
																	</Dropdown>
																</div>
															</div>
														</div>
													</template>
													<template v-else-if="DeviceCategory == 2">
														已处理
													</template>
													<template v-else>
														误报
													</template>
												</div>
											</div>
										</div>
										<div class="map-right-group-list-none" v-if="DeviceAbnormalList.length == 0">暂无告警消息</div>
									</div>
									<div class="user-top-list-page">
										<Page :total="DeviceAbnormalTotalCount" @on-change="DeviceAbnormalChange1" @on-page-size-change="DeviceAbnormalSizeChange1" size="small" show-total show-elevator show-sizer placement="top" />
									</div>
								</template>
								<template v-else-if="popupType == 4">
									<div class="map-bottom-content-tab">
										<div class="map-bottom-content-tab-item">设备名称</div>
										<div class="map-bottom-content-tab-item">设备编号</div>
										<div class="map-bottom-content-tab-item">设备地址</div>
										<div class="map-bottom-content-tab-item">在线状态</div>
										<div class="map-bottom-content-tab-item tabHandle">设备状态</div>
									</div>
									<div class="map-bottom-list" style="height: calc(100% - 1.75vw);">
										<div id="content" class="map-bottom-lists" v-if="DeviceCountList.length > 0">
											<div class="map-bottom-list-item" v-for="item in DeviceCountList" :key="item.Id">
												<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
												<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
												<div class="map-bottom-list-item-date">{{item.Address}}</div>
												<div class="map-bottom-list-item-date">{{item.IsOnline ? '在线' : '离线'}}</div>
												<div class="map-bottom-list-item-handle">{{item.SwitchStatus == 1 ? '合闸' : item.SwitchStatus == 2 ? '分闸' : '--'}}</div>
											</div>
										</div>
										<div class="map-right-group-list-none" v-if="DeviceCountList.length == 0">暂无告警消息</div>
									</div>
								</template>
								<template v-else-if="popupType == 5">
									<div class="map-bottom-content-tab">
										<div class="map-bottom-content-tab-item">所属小区</div>
										<div class="map-bottom-content-tab-item">住户地址</div>
										<div class="map-bottom-content-tab-item">业主名称</div>
										<div class="map-bottom-content-tab-item">联系电话</div>
										<div class="map-bottom-content-tab-item">报警时间</div>
									</div>
									<div class="map-bottom-list" style="height: calc(100% - 1.75vw);">
										<div id="content" class="map-bottom-lists" v-if="GetCurrRoomAbLists.length > 0">
											<div class="map-bottom-list-item" v-for="item in GetCurrRoomAbLists" :key="item.Id">
												<div class="map-bottom-list-item-device">{{item.VName}}</div>
												<div class="map-bottom-list-item-addr">{{`${item.Zhuang}幢-${item.Unit}单元-${item.Floor}楼-${item.RoomNo}房间`}}</div>
												<div class="map-bottom-list-item-date">{{item.OwnerName}}</div>
												<div class="map-bottom-list-item-date">{{item.OwnerPhone}}</div>
												<div class="map-bottom-list-item-date">{{item.CreateDate}}</div>
											</div>
										</div>
										<div class="map-right-group-list-none" v-if="GetCurrRoomAbLists.length == 0">暂无告警住户</div>
									</div>
								</template>
							</div>

						</dv-border-box-11>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Echarts from 'echarts'
	import Cookies from 'js-cookie'
	import $ from 'jquery'
	import api from '../../../api/yhj_request.js'
	export default {
		name: 'App',
		data() {
			return {
				GetAbDataLists: [], // 及时告警消息列表
				GetAbDataCount: 0, // 数量
				GetAbDataListsMsg: false,
				GetEchartAbDataMsg: false,
				GetNavDatas: {}, // 导航栏数据
				GetNavDataYHJs: {}, // 导航栏数据yhj
				processed: '', // 已处理数
				GetOperationDataList: [], // 当天操作日志数据列表
				GetOperationDataListMsg: false,
				cityName: '', // 获取地理位置
				GetDeviceDataLists: [], // 设备相关数据列表
				GetDeviceDataListsMsg: false,

				PlayIndex: false, // 播放按钮
				offsetMsg: false,

				popupState: false, // 弹窗状态
				popupType: 0, // 弹窗类型
				popupTitle: "", // 弹窗title
				pageIndex: 1,
				pageSize: 10,
				DeviceLists: [], // 设备列表
				DeviceTotal: 0, // 设备数量
				DeviceCategory: '',
				DeviceAbnormalList: [], // 报警列表
				DeviceAbnormalTotalCount: 0, // 报警数量
				DeviceCountList: [], // 当前报警设备
				GetCurrRoomAbLists: [], // 当前报警住户

				TittleName: '', // 中文title
				TittleNameEN: '', // 英文title
				ImageUrl: '',
				
				// 定时器
				t: null,
				timer: null,

			}
		},
		created() {
			let _this = this;

		},

		computed: {

		},

		watch: {

		},

		mounted() {
			let _this = this;

			// 判断当前用户是否超级管理员
			_this.IsOrNOSuperAdmin();

			// 根据集团 公司 部门获取设备异常（yhj）
			_this.GetDeviceAbnormalPageListWith3Code();

			// 获取导航栏数据
			_this.GetNavData();

			// 获取导航栏数据（yhj）
			_this.GetNavDataYHJ();

			// 图表在线离线数据（yhj）
			_this.GetDeviceZLData();

			// 告警异常处理情况图表数据
			_this.GetEchartAbData();

			// 当天操作日志数据（yhj）
			_this.GetOperationData();

			// 根据集团 公司 部门编号 等条件查询设备列表
			_this.GetUserDevicesPage();

			// 获取当前位置
			// _this.getPosition();

			_this.$nextTick(function() {
				_this.modeFlashing();
			});

			// setInterval(() => {
			//   _this.getNumScroll(_this.GetNavDataYHJs);
			// }, 10000);

		},
		methods: {

			// 刷新翻牌器
			getNumScroll(GetNavDataYHJs) {
				let _this = this;
				_this.numScroll('itemImg1', GetNavDataYHJs.todayAbSolve);
				_this.numScroll('itemImg2', GetNavDataYHJs.todayAbWeiSolve);
				_this.numScroll('itemImg4', GetNavDataYHJs.AbTenant);
				_this.numScroll('itemImg5', GetNavDataYHJs.abDevice);
				_this.numScroll('itemImg6', GetNavDataYHJs.ZxDevice);
				_this.numScroll('itemImg7', GetNavDataYHJs.LxDevice);
			},
			// 数字翻牌器
			numScroll(id, maxNum, time = 1000) {
				let numDom = document.getElementById(id)
				let numInit = 0
				let addNum = maxNum / (time / 10)
				let minTime = time / maxNum;
				let t = setInterval(function() {
					if (numInit >= maxNum) {
						clearInterval(t)
						if (numDom) {
							numDom.innerText = maxNum
						}						
					} else {
						numInit += addNum
						if (numDom) {
							numDom.innerText = Math.round(numInit)
						}						
					}
				}, 7)
			},

			modeFlashing() {

				let tmpe = 0;
				$(".mode-view-flashing").each(function(index) {
					let top = Math.ceil(Math.random() * $(document).height());
					let left = Math.ceil(Math.random() * $(document).width());
					$(this).offset({
						'left': left,
						'top': top
					});
					if (tmpe == 0) {
						$(this).addClass("flashing-delay0");
						$(this).addClass("flashing-duration4");
						tmpe = 1;
					} else if (tmpe == 1) {
						$(this).addClass("flashing-delay1_2");
						$(this).addClass("flashing-duration3");
						tmpe = 2;
					} else if (tmpe == 2) {
						$(this).addClass("flashing-delay0_7");
						$(this).addClass("flashing-duration2");
						tmpe = 3;
					} else if (tmpe == 3) {
						$(this).addClass("flashing-delay1_9");
						$(this).addClass("flashing-duration1");
						tmpe = 0;
					}

				})

			},

			Carousel() {
				this.roll(50);
			},

			roll(t) {

				var content = document.getElementById("content");
				var fakeContent = document.getElementById("fakeContent");
				var wrapper = document.getElementById("wrapper");

				let _this = this;

				if (!content) {
					return;
				}

				fakeContent.innerHTML = content.innerHTML;
				// 开始无滚动时设为0
				wrapper.scrollTop = 0;

				this.timer = null;

				//鼠标事件绑定
				$('#wrapper').hover(function() {
					clearInterval(this.timer);
					this.timer = null
				}, function() {
					this.timer = setInterval(() => {
						_this.rollStart(wrapper, content)
					}, t);
				}).mouseout();

			},

			// 开始滚动函数
			rollStart(wrapper, content) {
				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
				if (wrapper.scrollTop >= content.scrollHeight) {
					wrapper.scrollTop = 0;
				} else {
					wrapper.scrollTop++;
				}
			},

			// SignalR
			connectServer(value) {
				let _this = this;
				let conn = $.hubConnection("http://yhj.hxpwr.com/signalr/hubs", {
					useDefaultPath: false
				})
				_this.proxy = conn.createHubProxy("HomeHub");
				_this.proxy.on("SendBjCount", (data) => {
					if (data) {
						if (_this.PlayIndex) {
							_this.play = document.getElementById('Play');
							_this.play.play();
						}

						// 根据集团 公司 部门获取设备异常（yhj）
						_this.GetDeviceAbnormalPageListWith3Code();

						// 获取导航栏数据（yhj）
						_this.GetNavDataYHJ();

						// 告警异常处理情况图表数据
						_this.GetEchartAbData();

					}
				})
				conn.start().done((data) => {
					_this.proxy.invoke("sendLogin", value).done((msg) => {
						console.log('对接成功！');
					});
				}).fail((data) => {
					console.log('对接失败！')
				});
			},

			GetAbDeviceCount() {
				let _this = this;
				_this.play = document.getElementById('Play');
				_this.play.pause();
			},

			PlaySound() {
				this.PlayIndex = true;
				Cookies.set('PlayIndex', true);
			},

			StopSound() {
				this.PlayIndex = false;
				Cookies.set('PlayIndex', false);
			},

			ceshi() {
				this.offsetMsg = true;
				setTimeout(() => {
					this.offsetMsg = false;
				}, 2000)
			},

			// 判断当前用户是否超级管理员
			IsOrNOSuperAdmin() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: 'api/User/IsOrNOSuperAdmin',
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}).then(function(res) {
					// 连接SignalR
					// _this.connectServer(res.Data);
				}).catch(function(err) {
					if (err.data.Code == -9) {
						_this.$store.dispatch("setUserState", true);
						_this.$router.push({
							name: 'login'
						})
					} else if (err.data.Code == -1 && err.data.Message == '未找到身份认证信息，请重新登录') {
						_this.$router.push({
							name: 'login'
						})
					}
				});
			},

			// 根据集团 公司 部门编号 等条件查询设备列表
			GetUserDevicesPage() {

				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				_this.GetDeviceDataListsMsg = false;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetUserDevicesPage?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=1&pageSize=100`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					_this.GetDeviceDataListsMsg = true;

					if (res.Success) {
						_this.GetDeviceDataLists = res.Data;
						_this.$nextTick(function() {
							_this.Carousel();
						});
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					_this.GetDeviceDataListsMsg = true;
				});
			},

			// 获取当前位置
			getPosition() {
				let _this = this;
				// var geolocation = new BMap.Geolocation();
				// var gc = new BMap.Geocoder();
				// geolocation.getCurrentPosition(function (r) {
				// 	_this.cityName = `${r.address.province}-${r.address.city}`
				// 	Cookies.set('cityName', _this.cityName)
				// }, { enableHighAccuracy: true });
			},


			drawLine(legends, series) {
				let _this = this;
				if (!document.getElementById('myChart')) return;
				// 基于准备好的dom，初始化echarts实例
				let myChart = Echarts.init(document.getElementById('myChart'))
				// 绘制图表
				myChart.setOption({
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						bottom: 10,
						textStyle: {
							color: '#ffffff',
						},
						left: 'center',
						data: legends
					},
					series: [{
						name: '处理情况',
						type: 'pie',
						label: {
							// normal: {
							// 	position: 'inner',
							// 	show: false
							// },
							formatter: '{b}: {c} ({d}%)'
						},
						radius: '50%',
						center: ['50%', '50%'],
						data: series,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				});
				window.addEventListener('resize', function() {
					myChart.resize()
				})
				// 饼图点击跳转到指定页面
				myChart.on('click', function(param) {
					_this.openPopup(3, param.name == '已处理' ? '今日已处理' : param.name == '未处理' ? '今日未处理' : '今日误报', param.name ==
						'已处理' ? '2' : param.name == '未处理' ? '1' : '3')
				});
			},

			myChart1(series) {
				let _this = this;
				if (!document.getElementById('myChart1')) return;
				// 基于准备好的dom，初始化echarts实例
				let myChart = Echarts.init(document.getElementById('myChart1'))
				// 绘制图表
				myChart.setOption({
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},

					series: [{
						name: '设备状态',
						type: 'pie',
						radius: ['50%', '70%'],
						label: {
							formatter: '{b}: {c} ({d}%)'
						},
						data: series
					}]
				});

				window.addEventListener('resize', function() {
					myChart.resize()
				})

				// 饼图点击跳转到指定页面
				myChart.on('click', function(param) {
					_this.openPopup(2, param.name == '在线' ? '设备在线列表' : '设备离线列表', param.name == '在线' ? '1' : '0')
				});

			},

			// 根据集团 公司 部门获取设备异常（yhj）
			GetDeviceAbnormalPageListWith3Code(type) {

				if (!Cookies.get('yhjAdminData')) {
					this.$router.push({
						name: 'login'
					})
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				_this.GetAbDataListsMsg = false;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=1`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
					_this.GetAbDataListsMsg = true;
					if (res.Success) {

						_this.GetAbDataLists = res.Data;
						_this.GetAbDataCount = res.TotalCount;
						_this.numScroll('itemImg3', _this.GetAbDataCount);

						if (type == 'self') {
							_this.offsetMsg = true;
							setTimeout(() => {
								_this.offsetMsg = false;
							}, 2000)
						}

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},

			// 获取导航栏数据（旧接口，能用 取一个参数）
			GetNavData() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/Device/GetNavData`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}).then(function(res) {
					if (res.Success) {

						_this.GetNavDatas = res.Data;

					} else {
						if (res.Code == -9) {
							_this.$router.push({
								name: 'login'
							})
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}
				})
			},

			// 获取导航栏数据（yhj）
			GetNavDataYHJ() {

				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));

				_this.TittleName = yhjAdminData.TittleName;
				_this.TittleNameEN = yhjAdminData.TittleNameEN;
				_this.ImageUrl = yhjAdminData.ImageUrl;

				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetNavData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						_this.GetNavDataYHJs = res.Data;

						_this.getNumScroll(_this.GetNavDataYHJs);

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},

			// 图表在线离线数据（yhj）
			GetDeviceZLData() {
				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetDeviceZLData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						let series = [];
						res.Data.forEach((item, index) => {
							series.push({
								value: item.value,
								name: item.name,
								itemStyle: {
									color: index === 0 ? '#8256F3' : '#2AEED0'
								}
							})
						})
						_this.$nextTick(function() {
							_this.myChart1(series);
						});

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			// 告警异常处理情况图表数据
			GetEchartAbData() {
				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				_this.GetEchartAbDataMsg = false;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetEchartAbData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					_this.GetEchartAbDataMsg = true;

					if (res.Success) {

						let series = [],
							legends = [];
						res.Data.forEach((item, index) => {
							series.push({
								value: item.value,
								name: item.name,
								itemStyle: {
									color: index === 0 ? '#2094DF' : index === 1 ? '#2AEED0' : '#8256F3'
								}
							})
							legends.push(item.name);

							if (item.name == '已处理') {
								_this.processed = item.value
							}
						})

						if (series.length == 0) {
							series = [], legends = [];
							series.push({
								value: 0,
								name: '已处理',
								itemStyle: {
									color: '#2094DF'
								}
							})
							legends.push('已处理');

							_this.processed = 0
						}


						_this.$nextTick(function() {
							_this.drawLine(legends, series);
						});

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			// 当天操作日志数据（yhj）
			GetOperationData() {
				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				_this.GetOperationDataListMsg = false;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetOperationData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}&pageIndex=1&pageSize=100`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					_this.GetOperationDataListMsg = true;
					if (res.Success) {

						_this.GetOperationDataList = res.Data;

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			// 获取设备相关数据
			GetDeviceData() {
				let _this = this;
				_this.GetDeviceDataListsMsg = false;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/Device/GetDeviceData`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}).then(function(res) {
					_this.GetDeviceDataListsMsg = true;
					if (res.Success) {

						_this.GetDeviceDataLists = res.Data;

					} else {
						if (res.Code == -9) {
							_this.$router.push({
								name: 'login'
							})
						} else {
							_this.$Message['error']({
								background: true,
								content: res.Message
							});
						}
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			// 退出登录
			ok() {
				let _this = this;
				Cookies.set('yhjToken', '');
				Cookies.set('yhjAdminData', '');
				_this.$store.dispatch("setCodeValue", ``);
				_this.$router.push({
					name: 'login'
				});
			},
			cancel() {},

			// 前往智慧用电
			goPages() {
				let _this = this;
				_this.$router.push({
					name: 'smartElectricity'
				})
			},
			
			// 返回主页
			onBackClick() {
				let _this = this;
				
				// 清除储存后台返回位置
				Cookies.set('yhjCityName', '');
									
				// 清除token
				Cookies.set('yhjToken', '');
									
				// 清除集团部门编号
				Cookies.set('yhjAdminData', {});
									
				// 清除登录名
				Cookies.set('yhjUserLogin', '');
				_this.$router.push({
					name: 'index'
				})
			},

			// 开启弹窗
			openPopup(type, title, category = '') {
				let _this = this;
				_this.popupState = true;
				_this.popupType = type;
				_this.popupTitle = title;
				_this.pageIndex = 1;
				_this.pageSize = 10;

				if (type == 1) {
					_this.getDeviceAbnormalPages()
				} else if (type == 2) {
					_this.DeviceCategory = category;
					_this.getUserDevicesPages()
				} else if (type == 3) {
					_this.DeviceCategory = category;
					_this.getThatDayDeviceAbnormalPages();
				} else if (type == 4) {
					_this.GetCurrRoomAbDevices();
				} else if (type == 5) {
					_this.GetCurrRoomAbList();
				}

			},

			// 根据集团 公司 部门编号 等条件查询设备列表
			getUserDevicesPages() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetUserDevicesPage?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&onlineState=${_this.DeviceCategory}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {
						_this.DeviceLists = res.Data;
						_this.DeviceTotal = res.TotalCount;
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {

				});
			},
			DeviceChange(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.getUserDevicesPages()
			},
			DeviceSizeChange(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.getUserDevicesPages()
			},

			// 根据集团 公司 部门获取设备异常（yhj）
			getDeviceAbnormalPages() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&pstate=1`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						_this.DeviceAbnormalList = res.Data;
						_this.DeviceAbnormalTotalCount = res.TotalCount;

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},
			DeviceAbnormalChange(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.getDeviceAbnormalPages()
			},
			DeviceAbnormalSizeChange(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.getDeviceAbnormalPages()
			},

			//
			getThatDayDeviceAbnormalPages() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));

				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&pstate=${_this.DeviceCategory}&startDt=${_this.getNowFormatDate(new Date())}&endDt=${_this.getNowFormatDate(new Date())}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						_this.DeviceAbnormalList = res.Data;
						_this.DeviceAbnormalTotalCount = res.TotalCount;

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},
			DeviceAbnormalChange1(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.getThatDayDeviceAbnormalPages()
			},
			DeviceAbnormalSizeChange1(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.getThatDayDeviceAbnormalPages()
			},

			// 获取日期
			getNowFormatDate(date) {
				let seperator1 = "-";
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let strDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				let currentdate = year + seperator1 + month + seperator1 + strDate;
				return currentdate;
			},

			// 获取告警设备列表
			GetCurrRoomAbDevices() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));

				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetCurrRoomAbDevices?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {

					_this.DeviceCountList = res;

				})
			},

			// 当前报警住户列表
			GetCurrRoomAbList() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));

				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetCurrRoomAbList?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {

					_this.GetCurrRoomAbLists = res;

				})
			},

			// 及时告警信息处理 type 1、处理 2、误报（yhj）
			SolveAbData(Id, type, state) {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjDevice/ProcessUserDeviceAbnormal?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {
						_this.$Message['success']({
							background: true,
							content: res.Message
						});

						// 根据集团 公司 部门获取设备异常（yhj）
						_this.GetDeviceAbnormalPageListWith3Code();

						// 获取导航栏数据（yhj）
						_this.GetNavDataYHJ();

						// 告警异常处理情况图表数据
						_this.GetEchartAbData();

						// 判断当前用户是否超级管理员
						_this.IsOrNOSuperAdmin();

						if (_this.popupType == 1) {
							//
							_this.getDeviceAbnormalPages()
						} else if (_this.popupType == 3) {
							_this.getThatDayDeviceAbnormalPages();
						}


					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// _this.$Message['error']({
					//   background: true,
					//   content: '请求超时'
					// });
				});
			},
			// 关闭弹窗
			shutDown(type) {
				if (type == 'self') {
					let _this = this;
					_this.popupState = false;
				}
			}

		},
		filters: {
			intercept: function(value) {
				if (!value) return '';
				return value.slice(11, 16);
			},
		},
		beforeDestroy () {
			// 【路由销毁】:清除定时器
			console.log("路由销毁后");
			clearInterval(this.t);
			clearInterval(this.timer);
		},
	}
</script>
<style scoped>
	.outline-left>>>.ivu-spin-fix,
	.outline-right>>>.ivu-spin-fix {
		background-color: rgba(12, 63, 136, 0.3);
	}
	
	.user-top-list-page>>>.ivu-page-item,
	.user-top-list-page>>>.ivu-page-prev,
	.user-top-list-page>>>.ivu-page-next,
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		background-color: rgba(255, 255, 255, 0);
		min-width: 1.2vw;
		height: 1.2vw;
		line-height: 1.2vw;
		border-radius: 3px;
	}
	
	.user-top-list-page>>>.ivu-page-item>a,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		color: rgb(200, 200, 200);
		font-size: 0.6vw;
	}
	
	.user-top-list-page>>>.ivu-page-item-active a,
	.ivu-page-item-active:hover a {
		color: #2d8cf0;
	}
	
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		border: 0.05vw solid rgba(255, 255, 255, 0.2);
	}
	
	.user-top-list-page>>>.ivu-select-selected-value,
	.user-top-list-page>>>.ivu-page-options-elevator,
	.user-top-list-page>>>.ivu-page-total {
		color: rgba(255, 255, 255, 0.6);
	}
	
	
	#app>>>.ivu-dropdown-menu {
		width: 5vw;
		min-width: 5vw;
	}
	
	#app>>>.ivu-dropdown-item {
		padding: 0.35vw 0.7vw;
		font-size: 0.7vw !important;
	}
</style>
<style src="./smart_city.css" scoped></style>
